import { render, staticRenderFns } from "./approval-popup.vue?vue&type=template&id=19f351d2&"
import script from "./approval-popup.vue?vue&type=script&lang=ts&"
export * from "./approval-popup.vue?vue&type=script&lang=ts&"
import style0 from "./approval-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports